import { getSearchVertical } from 'services/api/microfwk';
import { brows } from 'react-router';
import { getMCSPlayButtonList } from '../../../NewSearchPage/redux/actions/multiContentSearch.actions';
import { browserHistory, Link } from 'react-router';
import {
  GET_TALENT_RESULT,
  SET_SHOW_MODAL_TALENT,
  SET_SELECT_ROLE_TALENT,
  SET_FILTER_ROLE_TALENT,
  SET_SHOW_ERROR_MODAL_TALENT,
  CLEAR_TALENT_INFO,
} from '../constants';
import { getBookmarks } from '../../../NewSearchPage/redux/actions/searchActions';
import { getRegion } from 'utils/Region';

export const getTalentResult = talentParams => async (dispatch, getState) => {
  const {
    token,
    selectTalentlId,
    byrFilterlist,
    userHash,
    id_rol = '',
    is_kids = '',
    provider_id = '',
  } = talentParams;
  const talentId =
    selectTalentlId ||
    browserHistory?.getCurrentLocation()?.pathname?.split('/')?.[3];
  let resultTalentSearch = [];
  const params = {
    field: 'TALENT',
    quantity: '20',
    value: talentId,
    filterlist: JSON.parse(byrFilterlist)[getRegion()].filterlist,
    api_version: 'v5.93',
    rank_days: '30',
    tenant_code: 'clarovideo',
    is_kids: is_kids,
    provider_id,
  };

  if (id_rol) {
    params.id_rol = id_rol;
  }

  //Obtiene los resultados del talento
  try {
    const response = await getSearchVertical(params);

    //OBTENER EL ESTATUS (PLAY) DE LOS RSULTADOS OBTENIDOS DE LA API SEACHVERTICAL
    dispatch(getMCSPlayButtonList(response?.response?.groups, token));

    //Agregar el bookmark si los resultados de talentos lo tienen
    if (userHash) {
      resultTalentSearch = await getBookmarks({
        contenidos: response?.response?.groups,
        user_hash: userHash,
        filterlist: JSON.parse(byrFilterlist)[getRegion()]?.filterlist,
      });
    } else {
      resultTalentSearch = response?.response?.groups;
    }
    //SE DISPARA EL EVENTO PARA GUARDAR LOS CONTENIDOS DEL TALENTO
    dispatch({
      type: GET_TALENT_RESULT,
      payload: resultTalentSearch,
    });
  } catch (error) {
    dispatch(setShowErrorModalTalent(true));
    console.log(error);
  }
};

export const setShowModalTalent = showModalTalent => dispatch => {
  dispatch({
    type: SET_SHOW_MODAL_TALENT,
    payload: showModalTalent,
  });
};

export const setSelectRoleTalent = role => dispatch => {
  dispatch({
    type: SET_SELECT_ROLE_TALENT,
    payload: role,
  });
};

export const setFilterRole = id => dispatch => {
  dispatch({
    type: SET_FILTER_ROLE_TALENT,
    payload: id,
  });
};

export const setShowErrorModalTalent = showModal => dispatch => {
  dispatch({
    type: SET_SHOW_ERROR_MODAL_TALENT,
    payload: showModal,
  });
};

export const clearTalentFilterInfo = () => dispatch => {
  dispatch({
    type: CLEAR_TALENT_INFO,
  });
};
